import React, { memo } from 'react'
import { Select, ISelectOption } from 'components/forms/Selects'
import { AWARD_TYPE_OPTIONS } from 'apps/rms/constants/shipperRates'
import { IShipperRate, AWARD_TYPE } from 'apps/rms/types/shipperRates'

interface IAwardTypeProps {
  value: RecursivePartial<IShipperRate>
  onChange(change: RecursivePartial<IShipperRate>): void
  error?: string
}

export const AwardType = memo<IAwardTypeProps>(({ error, onChange, value: { awardType } }) => {
  const awardTypeHandler = (e: ISelectOption<AWARD_TYPE>) => {
    onChange({ awardType: e.value })
  }

  return (
    <div className='col-md-4 col-xs-4'>
      <Select
        label='Award Type'
        options={AWARD_TYPE_OPTIONS}
        value={awardType}
        onChange={awardTypeHandler}
        dataTest='modal-award-type'
        required
        validationMessage={error}
        invalid={!!error}
      />
    </div>
  )
})
